import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getOrderById, updateOrder } from "../../Reducers/actions/ordersActions";
import Icon from "../../components/Icon/Icon";

import "./ShipmentDetails.scss";
import CreationSkeleton from "../../components/CreationCard/CreationSkeleton";
import Skeleton from "../../components/Skeleton/Skeleton";
import { clearTopNavbar, setTopNavbar } from "../../Reducers/actions/navbarActions";
import { ORDER_STATUS_COMPLETED, ORDER_STATUS_PENDING, ORDER_STATUS_SHIPPED } from "../../constants/globals";
import { useNavigate } from "react-router-dom";
import ShipmentCard from "../../components/ShipmentCard/ShipmentCard";

function ShipmentDetailsSkeleton() {
    return (
        <div className="shipment-container" role="status" aria-label="Loading shipment details">
            <div className="shipment-details px-16 d-flex f-column jcsb">
                <div>
                    <CreationSkeleton />
                    <div className="shipment-stepper mt-24">
                        <div className="px-12">
                            <div className="stepper-box">
                                <div className="stepper-line" aria-hidden />
                                {[1, 2, 3].map((i) => (
                                    <Skeleton key={i} width="32px" height="32px" borderRadius="50%" className="m-0 p-0" />
                                ))}
                            </div>
                            <div className="stepper-box pt-8">
                                {[1, 2, 3].map((i) => (
                                    <Skeleton key={i} width="72px" height="12px" borderRadius="6px" className="m-0 p-0" />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-16">
                    <Skeleton width="100%" height="50px" borderRadius="12px" className="m-0 p-0" />
                </div>
            </div>
        </div>
    );
}

function ShipmentDetails() {
    const params = useParams();
    const orderId = params.order_id; // Extract news_id from URL params
    const { order, loading, loading_update } = useSelector((state) => ({
        order: state?.orders?.currentOrder,
        loading: state?.orders?.loading,
        loading_update: state?.orders?.loading_update,
    }));

    const dispatch = useDispatch();
    const navigate = useNavigate()

    useEffect(() => {
        if (order?.order_id !== orderId) {
            dispatch(getOrderById(orderId));
        }
    }, [orderId, order?.order_id]);

    // Reset scroll position when component mounts
    useEffect(() => {
        dispatch(setTopNavbar({
            title: "My Purchases",
            showBackArrow: true,
        }))
        window.scrollTo(0, 0);

        return () => {
            dispatch(clearTopNavbar())
        }
    }, []);

    const statuses = [{
        icon: 'package',
        isActive: [ORDER_STATUS_PENDING, ORDER_STATUS_SHIPPED, ORDER_STATUS_COMPLETED].includes(order?.order_status),
        title: "Ordered"
    },
    {
        icon: 'delivery-truck',
        isActive: [ORDER_STATUS_SHIPPED, ORDER_STATUS_COMPLETED].includes(order?.order_status),
        title: "Shipped"
    },
    {
        icon: 'box-add',
        isActive: [ORDER_STATUS_COMPLETED].includes(order?.order_status),
        title: "Received"
    }]

    const handlePackageReceived = () => {
        dispatch(updateOrder(ORDER_STATUS_COMPLETED, order?.order_id))
    };

    const handleViewInMyLibrary = () => {
        navigate(`/library`)
    }

    if (loading || !order) {
        return <ShipmentDetailsSkeleton />;
    }
    return (
        <div className="shipment-container">

            <div className="shipment-details px-16 d-flex f-column jcsb">
                <div>
                    <ShipmentCard order={order}
                        thumbnail={order?.creation?.thumbnail_url}
                        title={order?.creation?.title}
                        userName={order?.creator?.userName}
                        creator={order?.creator}
                        profilePic={order?.creator?.profilePicture}
                        category={order?.creation?.category}
                        tags={order?.creation?.tags}
                        order_status={order?.order_status}
                        created_at={order?.created_at}
                        track={false}
                    //added those props to reuse the components 
                    />
                    <div className="shipment-stepper mt-24">
                        <div className="px-12">
                            <div className="stepper-box">
                                <div className="stepper-line"></div>
                                {statuses.map((status, index) => (
                                    <div
                                        key={index}
                                        className={`stepper-icon ${status.isActive ? "active" : ""}`}
                                    >
                                        <Icon alias={status.icon} color="#fff" width={24} height={24} />

                                    </div>

                                ))}
                            </div>

                            <div className="stepper-box pt-8">
                                {statuses.map((status, index) => (
                                    <div
                                        key={index}
                                        className={`stepper-icon-text`}
                                    >
                                        {status.title}
                                    </div>
                                ))}
                            </div>
                        </div>
                        {order?.order_status === ORDER_STATUS_SHIPPED && <button
                            onClick={handlePackageReceived}
                            className="btn red-btn btn-full mt-16 py-24 d-flex jcc aic h-50px"
                            disabled={loading_update}
                        >
                            <span className="button-title">I received my package</span>
                        </button>}
                    </div>
                </div>

                <div >
                    <button
                        onClick={handleViewInMyLibrary}
                        className="btn red-outline-btn btn-full py-24 d-flex jcc aic mt-16 h-50px"
                    >
                        <span className="button-title">View in my Library</span>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ShipmentDetails;
